let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4ji3C")).then(() => parcelRequire('aM5VR'));